import language from './language'

const localization = {
    language: Object.assign(language, language),
}

export default localization